import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "input-group my-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hashtag" })
], -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "input-group my-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-at" })
], -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Communication Options", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-switch my-3" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input",
    type: "checkbox",
    id: "flexSwitchCheckChecked",
    checked: ""
  }),
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label",
    for: "flexSwitchCheckChecked"
  }, "Send me product updates")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        disabled: "",
        type: "text",
        class: "form-control",
        placeholder: "Username",
        "aria-label": "Username",
        "aria-describedby": "basic-addon1",
        value: _ctx.$auth.userId
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("input", {
        disabled: "",
        type: "text",
        class: "form-control",
        placeholder: "Username",
        "aria-label": "Username",
        "aria-describedby": "basic-addon1",
        value: _ctx.$auth.user.email
      }, null, 8, _hoisted_7)
    ]),
    _hoisted_8,
    _hoisted_9
  ]))
}